import { withI18n } from 'react-i18next';
import PartView from './PartView';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { cartActions, cartItemCountSel } from 'src/store/modules/cart';

import { analyticsActions } from 'src/analytics/store';
import { userDataSel } from 'src/store/modules/user';

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  updateCart: () => dispatch(cartActions.getInfo()),
  fireProductDetailEvent: (data: any) =>
    dispatch(analyticsActions.productDetail(data)),
  fireProductAddedToCartEvent: (data: any) =>
    dispatch(analyticsActions.productAddToCart(data))
});

const mapStateToProps = (state: IInitialState) => ({
  cartItemsCount: cartItemCountSel(state),
  userData: userDataSel(state)
});

export const pureComponent = PartView;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(PartView));

interface IDispatchFromProps {
  updateCart: () => void;
  fireProductDetailEvent(data: any): void;
  fireProductAddedToCartEvent(data: any): void;
}
